<template>
  <div class="home">
    <!-- Begin slider -->
    <Slider
      v-waypoint="{
        active: true,
        callback: onWaypoint,
        options: intersectionOptions
      }"
    />
    <!-- // -->
    <!-- Begin video -->
    <Video
      v-waypoint="{
        active: true,
        callback: onWaypoint,
        options: intersectionOptions
      }"
    />
    <!-- // -->
    <!-- Begin about drug -->
    <AboutDrug
      v-waypoint="{
        active: true,
        callback: onWaypoint,
        options: intersectionOptions
      }"
    />
    <!-- // -->
    <!-- Begin device -->
    <Device
      :isResponsive="isResponsive"
      v-waypoint="{
        active: true,
        callback: onWaypoint,
        options: intersectionOptions
      }"
    />
    <!-- // -->
    <!-- Begin efficiency -->
    <Efficiency
      v-waypoint="{
        active: true,
        callback: onWaypoint,
        options: intersectionOptions
      }"
    />
    <!-- // -->
    <!-- Begin security profile -->
    <SecurityProfile
      v-waypoint="{
        active: true,
        callback: onWaypoint,
        options: intersectionOptions
      }"
    />
    <!-- // -->
    <!-- Begin application -->
    <Application
      v-waypoint="{
        active: true,
        callback: onWaypoint,
        options: intersectionOptions
      }"
    />
    <!-- // -->
    <!-- Begin rynit -->
    <Rynit
      v-waypoint="{
        active: true,
        callback: onWaypoint,
        options: { threshold: [0.15] }
      }"
    />
    <!-- // -->
    <!-- Begin bibliography -->
    <section class="bibliography">
      <div class="container">
        <div class="bibliography__info">
          <p v-html="$t('bibliography.info_1')"></p>
          <p v-html="$t('bibliography.info_2')"></p>
        </div>
        <div class="bibliography__list">
          <h3
            class="bibliography__list-title"
            v-html="$t('bibliography.bibliographyTitle')"
          ></h3>
          <div
            class="bibliography__list-item"
            v-for="(item, key) in $t('home.bibliography.list')"
            :key="key"
          >
            <div class="bibliography__list-number">{{ key + 1 }}.</div>
            <div class="bibliography__list-text" v-html="item"></div>
          </div>
        </div>
      </div>
    </section>
    <!-- // -->
  </div>
</template>

<script>
import Slider from "@/components/home/Slider";
import Video from "@/components/home/Video";
import AboutDrug from "@/components/home/AboutDrug";
import Device from "@/components/home/Device";
import Efficiency from "@/components/home/Efficiency";
import SecurityProfile from "@/components/home/SecurityProfile";
import Application from "@/components/home/Application";
import Rynit from "@/components/home/Rynit";
export default {
  name: "HomeView",
  metaInfo() {
    // metatags for Slider block
    if (this.$route.path === "/ua/" && this.$i18n.locale === "ua") {
      return {
        title: "Називін® Сенситив 🤧 Засіб від нежитю ⏳ Діє до 12 годин",
        meta: [
          {
            name: "description",
            content:
              "Засіб від нежитю Називін® Сенситив 🤧 Лікарський засіб, який ефективно допомагає відновити носове дихання 👃 Заходьте на сайт та дізнайтеся більше!"
          },
          {
            property: "og:description",
            content: "Називін® Сенситив 🤧 Засіб від нежитю ⏳ Діє до 12 годин"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    } else if (this.$route.path === "/ru/" && this.$i18n.locale === "ru") {
      return {
        title: "Називин® Сенситив 🤧 От насморка ⏳ Действует до 12 часов",
        meta: [
          {
            name: "description",
            content:
              "Средство от насморка Називин® Сенситив 🤧 Лекарственный препарат, который эффективно помогает восстановить носовое дыхание 👃 Заходите на сайт и узнайте больше!"
          },
          {
            property: "og:description",
            content: "Називин® Сенситив 🤧 От насморка ⏳ Действует до 12 часов"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    }
    // metatags for Video block
    else if (this.$route.meta.hash === "video" && this.$i18n.locale === "ua") {
      return {
        title: "Називін® Сенситив - відео 🎞 Як працює препарат",
        meta: [
          {
            name: "description",
            content: "Швидко і ефективно! Дивитись відео, як працює препарат"
          },
          {
            property: "og:description",
            content: "Називін® Сенситив - відео 🎞 Як працює препарат"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    } else if (
      this.$route.meta.hash === "video" &&
      this.$i18n.locale === "ru"
    ) {
      return {
        title: "Називин® Сенситив - видео 🎞 Как работает препарат",
        meta: [
          {
            name: "description",
            content: "Бысро и эффективно! Смотреть видео, как работает препарат"
          },
          {
            property: "og:description",
            content: "Називин® Сенситив - видео 🎞 Как работает препарат"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    }
    // metatags for About Drug block
    if (
      this.$route.meta.hash === "pro-preparat" &&
      this.$i18n.locale === "ua"
    ) {
      return {
        title: "Як вам допоможе Називін® Сенситив?",
        meta: [
          {
            name: "description",
            content:
              "Засіб від нежитю Називін® Сенситив 🤧 Звужує кровоносні судини носа, усуває набряк слизової оболонки, відновлює дихання 👃💦"
          },
          {
            property: "og:description",
            content: "Як вам допоможе Називін® Сенситив?"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    } else if (
      this.$route.meta.hash === "o-preparate" &&
      this.$i18n.locale === "ru"
    ) {
      return {
        title: "Как вам поможет Називин® Сенситив?",
        meta: [
          {
            name: "description",
            content:
              "Средство от насморка Називин® Сенситив 🤧 сужает кровеносные сосуды носа, устраняет отек слизистой оболочки, восстанавливает дыхание 👃💦"
          },
          {
            property: "og:description",
            content: "Как вам поможет Називин® Сенситив?"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    }
    // metatags for Device block
    if (this.$route.meta.hash === "prystriy" && this.$i18n.locale === "ua") {
      return {
        title: "Що особливого в дозуючому пристрої Називін® Сенситив?",
        meta: [
          {
            name: "description",
            content:
              "Має особливий пристрій доставки препарату в організм ⚙ Це дозволяє: зберігати стерильність 🧼 без консерванта та користуватися до 12 місяців після відкриття ⏳"
          },
          {
            property: "og:description",
            content: "Що особливого в дозуючому пристрої Називін® Сенситив?"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    } else if (
      this.$route.meta.hash === "ustroystvo" &&
      this.$i18n.locale === "ru"
    ) {
      return {
        title: "Что особенного в дозирующем устройства Називин® Сенситив?",
        meta: [
          {
            name: "description",
            content:
              "Имеет особое устройство доставки препарата в организм ⚙ Это позволяет сохранять стерильность 🧼 без консерванта и пользоваться до 12 месяцев после открытия ⏳"
          },
          {
            property: "og:description",
            content: "Что особенного в дозирующем устройства Називин® Сенситив?"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    }
    // metatags for Efficiency block
    if (this.$route.meta.hash === "efektyvnist" && this.$i18n.locale === "ua") {
      return {
        title: "Називін® Сенситив Ефективність",
        meta: [
          {
            name: "description",
            content:
              "Усунути нежить 👃💦 та одужати! Після застосування полегшення нежитю вже через 25 секунд ⏱ Тривалість дії до 12 годин ⌛ Скорочує тривалість риніту на 2 дні 📅"
          },
          {
            property: "og:description",
            content: "Називін® Сенситив Ефективність"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    } else if (
      this.$route.meta.hash === "effektivnost" &&
      this.$i18n.locale === "ru"
    ) {
      return {
        title: "Називин® Сенситив Эффективность",
        meta: [
          {
            name: "description",
            content:
              "Устранить насморк 👃💦 и выздороветь! После применения облегчения насморка уже через 25 секунд ⏱ Продолжительность действия до 12:00 ⌛ сокращает продолжительность ринита на 2 дня 📅"
          },
          {
            property: "og:description",
            content: "Називин® Сенситив Эффективность"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    }
    // metatags for Security Profile block
    if (
      this.$route.meta.hash === "profil-bezpeky" &&
      this.$i18n.locale === "ua"
    ) {
      return {
        title: "Називін® Сенситив Профіль безпеки",
        meta: [
          {
            name: "description",
            content:
              "Без консерванту бензалконію хлориду, що покращує переносимість та знижує ризик звикання💉 Ментол, камфора відсутні і знижують ризик алергії та гіперчутливість✋"
          },
          {
            property: "og:description",
            content: "Називін® Сенситив Профіль безпеки"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    } else if (
      this.$route.meta.hash === "profil-bezopasnosti" &&
      this.$i18n.locale === "ru"
    ) {
      return {
        title: "Називин® Сенситив Профиль безопасности",
        meta: [
          {
            name: "description",
            content:
              "Без консерванта бензалкония хлорида, что улучшает переносимость и снижает риск звикання💉 Ментол, камфора отсутствуют и снижают риск аллергии и гиперчутливисть✋"
          },
          {
            property: "og:description",
            content: "Називин® Сенситив Профиль безопасности"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    }
    // metatags for Application block
    if (
      this.$route.meta.hash === "zastosuvannya" &&
      this.$i18n.locale === "ua"
    ) {
      return {
        title: "Називін® Сенситив Застосування",
        meta: [
          {
            name: "description",
            content:
              "Для дорослих та дітей від 6 років 🧔👶 По 1 впорскуванню у кожен носовий хід 👃 2-3 рази на добу📆"
          },
          {
            property: "og:description",
            content: "Називін® Сенситив Застосування"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    } else if (
      this.$route.meta.hash === "primeneniye" &&
      this.$i18n.locale === "ru"
    ) {
      return {
        title: "Називин® Сенситив Применение",
        meta: [
          {
            name: "description",
            content:
              "Для взрослых и детей от 6 лет 🧔👶 по 1 впрыскиванию в каждый носовой ход 👃 2-3 раза в добу📆"
          },
          {
            property: "og:description",
            content: "Називин® Сенситив Применение"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    }
    // metatags for Rynit block
    if (this.$route.meta.hash === "rynit" && this.$i18n.locale === "ua") {
      return {
        title: "Називін® Сенситив при ринітах Рекомендації",
        meta: [
          {
            name: "description",
            content:
              "Прості поради ✅: Повноцінне харчування 🥗 Активний спосіб життя 🏋‍♀ Без шкідливих звичок 🚭 Уникнення перепадів температури 🌡 Регулярне вологе прибирання 🧹"
          },
          {
            property: "og:description",
            content: "Називін® Сенситив при ринітах Рекомендації"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    } else if (
      this.$route.meta.hash === "rinit" &&
      this.$i18n.locale === "ru"
    ) {
      return {
        title: "Називин® Сенситив при ринитах Рекомендации",
        meta: [
          {
            name: "description",
            content:
              "Простые советы ✅: Полноценное питание 🥗 Активный образ жизни 🏋♀ Без вредных привычек 🚭 Избежание перепадов температуры 🌡 Регулярная влажная уборка 🧹"
          },
          {
            property: "og:description",
            content: "Називин® Сенситив при ринитах Рекомендации"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    }
  },
  data() {
    return {
      isResponsive: false,
      root: null,
      utm: null,
      rootMargin: "0px 0px 0px 0px",
      intersectionOptions: {
        threshold: [0.5, 1]
      }
    };
  },
  components: {
    Slider,
    Video,
    AboutDrug,
    Device,
    Efficiency,
    SecurityProfile,
    Application,
    Rynit
  },
  beforeMount() {
    const queryString = window.location.search;
    this.utm = queryString;
  },
  methods: {
    onWaypoint({ going, el }) {
      if (going === this.$waypointMap.GOING_IN) {
        this.$router
          .push({
            path: `/${this.$i18n.locale}/${el.id === "slider" ? "" : el.id}${this.utm}`
          })
          .catch(() => {});
      }
    },
    changeElementsPositions() {
      if (this.isResponsive) {
        var deviceBtn = document.querySelector(".device__description-btn");
        document
          .querySelector(".device__image")
          .parentNode.appendChild(deviceBtn);
        var efficiencyBtn = document.querySelector(
          ".efficiency__description-btn"
        );
        document
          .querySelector(".efficiency__image")
          .parentNode.appendChild(efficiencyBtn);
        var securityProfileImage = document.querySelector(
          ".security-profile__image"
        );
        var securityProfileBtn = document.querySelector(
          ".security-profile__description-btn"
        );
        securityProfileBtn.parentNode.insertBefore(
          securityProfileImage,
          securityProfileBtn
        );
      }
    },
    responsive() {
      if (window.innerWidth <= 767) {
        this.isResponsive = true;
        this.changeElementsPositions();
      }
    }
  },
  mounted() {
    this.responsive();
    var hash = this.$route.meta.hash;
    var headerHeight = document.querySelector(".header").offsetHeight;
    window.scrollTo({
      top: document.getElementById(hash).offsetTop - headerHeight + 1,
      left: 0,
      behavior: "auto"
    });
  }
};
</script>
<style lang="scss">
@import "@/assets/scss/views/_home";
</style>
